import * as React from 'react';
import {Icon, Modal, Button, Form} from 'semantic-ui-react';

import _get from 'lodash/get';
import _set from 'lodash/set';

import i18n from "../../../../locale/i18n";
import RestClientInstance from "../../../../lib/RestClient";

const t = i18n.t.bind(i18n);

interface FileManagementModalProps {
    handleRefresh: Function
}

interface FileManagementModalState {
    open: boolean,
    data: any
}

class FileManagementModal extends React.Component<FileManagementModalProps, FileManagementModalState> {

    isLoading: Boolean = false;

    constructor(props: FileManagementModalProps) {
        super(props);

        this.state = {
            open: false,
            data: {}
        };

        this.refresh = this.refresh.bind(this);
    }

    delete () {
        RestClientInstance.delete("file/" + this.state.data.storedFileId).then(
            ()=> {
                this.refresh(false, {});
                window.location.reload();
            }, ()=> {

            }
        )
    }

    save() {

        let fileData = {...this.state.data};

        fileData["file"] = undefined;

        let file = this.state.data.file;

        let formData = new FormData();

        formData.append("file", file);
        formData.append("fileData", JSON.stringify(fileData));

        RestClientInstance.post("file", formData).then(
            ()=> {
                this.refresh(false, {});
                window.location.reload();
            }, ()=> {

            }
        )
    }

    componentDidMount() {
        this.props.handleRefresh(this.refresh);
    }

    refresh(open: boolean, data: any) {
        this.setState(
            {
                open: open,
                data: data
            }
        )
    }

    changeSection (sectionName: string) {
            let sections = _get(this.state.data, "data.sections") || [];

            if (sections.includes(sectionName)) {
                sections = sections.filter((section : string) => section !== sectionName);
            } else {
                sections.push(sectionName);
            }
            this.onChange("data.sections" ,sections);
    }

    onChange (key: string, value: any, callback?: ()=> void) {
        let data = {...this.state.data};
        _set(data, key, value);

        this.setState({data: data}, callback);
    }

    render() {

        let sections = _get(this.state.data, "data.sections") || [];

        return(
            <Modal open={this.state.open}
                   trigger={
                       <Button icon labelPosition='right' onClick={()=>{this.refresh(true, {})}}>
                           {t("FileManagement.UploadDocument")}
                           <Icon name="upload" />
                       </Button>
                   }
            >

                <Modal.Header>{t("FileManagement.UploadEditDocument")}</Modal.Header>
                <Modal.Content scrolling>

                    <Form>

                        {
                            (!this.state.data.storedFileId) ?
                                <>
                                    {this.state.data.file ?
                                        <p>{this.state.data.file.name}</p>
                                        : <></>}

                                    <Button
                                        content={t("Common.ChooseFile")}
                                        as={"label"}
                                        icon="file"
                                        htmlFor={"file"}
                                    />
                                    <input type="file" id="file" style={{ display: "none" }} onChange={(event) => {
                                        if (!event.target.files)
                                            return;

                                        this.onChange("file" ,event.target.files[0], ()=> {
                                            this.onChange("filename" ,this.state.data.file.name);
                                        });
                                    }} />
                                    <br/>
                                    <br/>
                                </>
                                : <></>
                        }

                        <Form.Input
                            label={t("FileManagement.Filename")}
                            name="filename"
                            type="string"
                            required={true}
                            value={this.state.data.filename}
                            onChange={(event) =>this.onChange("filename" ,event.target.value)}
                        />

                        <label><b>{t("FileManagement.Sections")}:</b></label>

                        <br/>
                        <br/>

                        <Form.Checkbox
                            label={t("Route.Contracts")}
                            type={"checkbox"}
                            checked={sections.includes("contracts")}

                            onChange={()=>{this.changeSection("contracts")}}
                        />

                        <Form.Checkbox
                            label={t("Route.DeliveryContract")}
                            type={"checkbox"}
                            checked={sections.includes("deliveryContract")}

                            onChange={()=>{this.changeSection("deliveryContract")}}
                        />

                        <Form.Checkbox
                            label={t("Route.DeliveryRegulation")}
                            type={"checkbox"}
                            checked={sections.includes("deliveryRegulation")}
                            onChange={()=>{this.changeSection("deliveryRegulation")}}
                        />

                        <Form.Checkbox
                            label={t("Route.ScaleOfCharges")}
                            type={"checkbox"}
                            checked={sections.includes("scaleOfCharges")}
                            onChange={()=>{this.changeSection("scaleOfCharges")}}
                        />


                        <Form.Checkbox
                            label={t("Route.Membership")}
                            type={"checkbox"}
                            checked={sections.includes("membership")}
                            onChange={()=>{this.changeSection("membership")}}
                        />

                        <Form.Checkbox
                            label={t("Route.Statutes")}
                            type={"checkbox"}
                            checked={sections.includes("statutes")}
                            onChange={()=>{this.changeSection("statutes")}}
                        />

                        <Form.Checkbox
                            label={t("Route.DeclarationOfAccession")}
                            type={"checkbox"}
                            checked={sections.includes("declarationOfAccession")}
                            onChange={()=>{this.changeSection("declarationOfAccession")}}
                        />

                        <Form.Checkbox
                            label={t("Route.Logistics")}
                            type={"checkbox"}
                            checked={sections.includes("logistics")}
                            onChange={()=>{this.changeSection("logistics")}}
                        />

                        <Form.Checkbox
                            label={t("Route.RVPrices")}
                            type={"checkbox"}
                            checked={sections.includes("rvPrices")}
                            onChange={()=>{this.changeSection("rvPrices")}}
                        />

                        <Form.Checkbox
                            label={t("Route.IT")}
                            type={"checkbox"}
                            checked={sections.includes("it")}
                            onChange={()=>{this.changeSection("it")}}
                        />

                        <Form.Checkbox
                            label={t("Route.Systems")}
                            type={"checkbox"}
                            checked={sections.includes("systems")}
                            onChange={()=>{this.changeSection("systems")}}
                        />

                        <Form.Checkbox
                            label={t("Route.Maintenance")}
                            type={"checkbox"}
                            checked={sections.includes("maintenance")}
                            onChange={()=>{this.changeSection("maintenance")}}
                        />

                        <Form.Checkbox
                            label={t("Route.QualityManagement")}
                            type={"checkbox"}
                            checked={sections.includes("qualityManagement")}
                            onChange={()=>{this.changeSection("qualityManagement")}}
                        />

                        <Form.Checkbox
                            label={t("Route.GlobalGAP")}
                            type={"checkbox"}
                            checked={sections.includes("globalGap")}
                            onChange={()=>{this.changeSection("globalGap")}}
                        />

                        <Form.Checkbox
                            label={t("Route.GeneralRegulations")}
                            type={"checkbox"}
                            checked={sections.includes("globalGap-generalRegulations")}
                            onChange={()=>{this.changeSection("globalGap-generalRegulations")}}
                        />

                        <Form.Checkbox
                            label={t("Route.FlowersOrnamentalPlants")}
                            type={"checkbox"}
                            checked={sections.includes("globalGap-FlowersOrnamentalPlants")}
                            onChange={()=>{this.changeSection("globalGap-FlowersOrnamentalPlants")}}
                        />

                        <Form.Checkbox
                            label={t("Route.Requirements")}
                            type={"checkbox"}
                            checked={sections.includes("globalGap-FlowersOrnamentalPlants-Requirements")}
                            onChange={()=>{this.changeSection("globalGap-FlowersOrnamentalPlants-Requirements")}}
                        />

                        <Form.Checkbox
                            label={t("Route.SampleDocumentsBP")}
                            type={"checkbox"}
                            checked={sections.includes("globalGap-FlowersOrnamentalPlants-SampleDocumentsBP")}
                            onChange={()=>{this.changeSection("globalGap-FlowersOrnamentalPlants-SampleDocumentsBP")}}
                        />

                        <Form.Checkbox
                            label={t("Route.GRASPV2")}
                            type={"checkbox"}
                            checked={sections.includes("globalGap-GRASPV2")}
                            onChange={()=>{this.changeSection("globalGap-GRASPV2")}}
                        />

                        <Form.Checkbox
                            label={t("Route.FruitVegetablesHerbs")}
                            type={"checkbox"}
                            checked={sections.includes("globalGap-FruitVegetablesHerbs")}
                            onChange={()=>{this.changeSection("globalGap-FruitVegetablesHerbs")}}
                        />

                        <Form.Checkbox
                            label={t("Route.Requirements")}
                            type={"checkbox"}
                            checked={sections.includes("globalGap-FruitVegetablesHerbs-Requirements")}
                            onChange={()=>{this.changeSection("globalGap-FruitVegetablesHerbs-Requirements")}}
                        />

                        <Form.Checkbox
                            label={t("Route.SampleDocuments")}
                            type={"checkbox"}
                            checked={sections.includes("globalGap-FruitVegetablesHerbs-SampleDocuments")}
                            onChange={()=>{this.changeSection("globalGap-FruitVegetablesHerbs-SampleDocuments")}}
                        />

                        <Form.Checkbox
                            label={t("Route.CBPlants")}
                            type={"checkbox"}
                            checked={sections.includes("globalGap-FruitVegetablesHerbs-SampleDocuments-CBPlants")}
                            onChange={()=>{this.changeSection("globalGap-FruitVegetablesHerbs-SampleDocuments-CBPlants")}}
                        />

                        <Form.Checkbox
                            label={t("Route.FVFruitsVegetables")}
                            type={"checkbox"}
                            checked={sections.includes("globalGap-FruitVegetablesHerbs-SampleDocuments-FVFruitsVegetables")}
                            onChange={()=>{this.changeSection("globalGap-FruitVegetablesHerbs-SampleDocuments-FVFruitsVegetables")}}
                        />

                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    {
                        this.state.data.storedFileId ?
                            <Button color={"red"} onClick={()=>{this.delete()}}>
                                {t("Common.Delete")}
                            </Button> : <></>
                    }

                    <Button default onClick={()=>{this.refresh(false, {})}}>
                        {t("Common.Cancel")}
                    </Button>
                    <Button primary onClick={()=>{this.save()}}>
                        {t("Common.Save")}
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default FileManagementModal;